<template>
  <article class="bic-list__bic-item bic-item bic-item--alternate">
    <button class="bic-item__alt-close" v-on:click="clearAlternateBic"></button>
    <h3 class="bic-item__title">{{ item.desc }}</h3>
    
    <div class="bic-item__subtitle">
      <div class="bic-item__code-label">Business Industry Code:<span class="bic-item__code"> {{ item.code }}</span></div>
    </div>
  
    <div class="bic-item__details">
      <div v-if="item.important" class="important">{{ item.important }}</div>

      <!-- DEFINITION -->
      <div v-if="item.definition" class="definition" v-html="item.definition"></div>
      <div v-if="!item.definition" class="noDefinition">Click 'More' to see Classification Unit and ANZSIC codes.</div>
      
      <!-- HISTORY -->
      <div v-if="item.historyYear" class="bic-item__section">
        <b>Valid from:</b><br/>
        <div class="bic-item__section-content">This code is only valid for registrations after 1 April {{ item.historyYear }} and tax returns for {{ item.historyYear }} onwards.</div>
        <div v-if="item.historyBicId" class="bic-item__section-content">For earlier years use {{ item.historyBic.code }} {{ item.historyBic.desc }}</div>
      </div>

      <!-- CLASSIFICATION UNIT (CU) -->
      <div class="bic-item__section">
          <div class="bic-item__section-header">Classification Unit (CU): {{ item.cu.code }}</div>
          <div class="bic-item__section-header">{{ item.cu.desc }}</div>
          <div class="bic-item__section-content">This is used by ACC to calculate your levies. <a id target="_blank" href="https://www.acc.co.nz/Calculator" class="external">Calculate your levies</a></div>
      </div>

      <div class="bic-item__section">
          <div class="bic-item__section-header">ANZSIC: {{ item.anzsic.code }}</div>
          <div class="bic-item__section-header">{{ item.anzsic.desc }}</div>
          <div class="bic-item__section-content">Statistics NZ uses this to compile and analyse industry statistics.</div>
      </div>
    </div>
  </article>
</template>

<script>
  import Vue from 'vue';
  import BicItemRef from './BicItemRef.vue';

  export default Vue.component('BicItemAlternate', {
    props: {
      item: Object,
      clearAlternateBic: Function,
    },
    data: function() {
      return {
        expanded: false,
      };
    },
  });
</script>